import { fetchList as fetchProductAttrList, getAttribute } from '@/api/attribute'
import { inventoryType } from './constants';
import { useShopDataStore } from '@/stores/shopData';

// export function getAllCategoryList(productCategoryList, excludeNames, hasNoSubLevel) {
//   let productCateOptions = [];
//   for (let i = 0; i < productCategoryList.length; i++) {
//     const parentCategory = productCategoryList[i];
//     let children = [];
//     let subChildren = [];
//     if (!excludeNames.includes(parentCategory.name)) {
//       if (!hasNoSubLevel && parentCategory.children != null && parentCategory.children.length > 0) {
        
//         for (let j = 0; j < parentCategory.children.length; j++) {
//           const childCategory = parentCategory.children[j];
//           if(childCategory.parentId == -1){
//             subChildren.push({
//               label: childCategory.name,
//               value: childCategory.id,
//             });
//           }
//           else{
//             children.push({
//               label: childCategory.name,
//               value: childCategory.id,
//             });
//           }
//         }

//         if(parentCategory.name == 'Diamonds' || parentCategory.name == 'Gems'){
//             children.push({
//               label: 'Unique',
//               value: -1,
//               children: subChildren.length > 0 ? subChildren : undefined
//             });
//         }
//       }

//       productCateOptions.push({
//         label: parentCategory.name,
//         value: parentCategory.id,
//         children:children.length > 0 ? children : undefined,
//       });
//     }
//   }
//   return productCateOptions;
// }

export function getAllCategoryList(productCategoryList, includeNames, hasNoSubLevel) {
  const includeSet = new Set(includeNames);
  const productCateOptions = [];

  productCategoryList.forEach((parentCategory) => {
    if (includeSet.size > 0 && !includeSet.has(parentCategory.name)) return;

    let children = [];
    let subChildren = [];

    if (!hasNoSubLevel && Array.isArray(parentCategory.children) && parentCategory.children.length > 0) {
      parentCategory.children.forEach((childCategory) => {
        const option = {
          label: childCategory.name,
          value: childCategory.id,
        };

        if (childCategory.parentId === -1) {
          subChildren.push(option);
        } else {
          children.push(option);
        }
      });

      if (parentCategory.name === 'Diamonds' || parentCategory.name === 'Gems') {
        // Push "Unique" to the top of children
        children.unshift({
          label: 'Unique',
          value: -1,
          children: subChildren.length > 0 ? subChildren : undefined,
        });
      }
    }

    productCateOptions.push({
      label: parentCategory.name,
      value: parentCategory.id,
      children: children.length > 0 ? children : undefined,
    });
  });

  return productCateOptions;
}


// export function getProductCateList(productCategoryList) {
//   let list = productCategoryList
//   let productCateOptions = []
//   for (let i = 0; i < list.length; i++) {
//     let children = []
//     if (list[i].name != "Golds" && list[i].name != "Diamonds" && list[i].name != "Gems" && list[i].name != "Big Stones") {
//       if (list[i].children != null && list[i].children.length > 0) {
//         for (let j = 0; j < list[i].children.length; j++) {
//           children.push({ label: list[i].children[j].name, value: list[i].children[j].id })
//         }
//       }
//       productCateOptions.push({ label: list[i].name, value: list[i].id, children: children })
//     }
//   }
//   return productCateOptions
// }

// export function  getCategoryNameById(categoryOptions, id) {
//     let name = null
//     for (let i = 0; i < categoryOptions.length; i++) {
//       if(categoryOptions[i].children){
//         for (let j = 0; j < categoryOptions[i].children.length; j++) {
//           if (categoryOptions[i].children[j].value === id) {
//               name = categoryOptions[i].children[j].label
//               return name
//           }
//         }
//       }
//       else{
//         if (categoryOptions[i].value === id) {
//             name = categoryOptions[i].label
//             return name
//         }
//       }
       
//     }
//     return name
// }

export function getCategoryNameById(categoryOptions, id, length) {
  for (const parent of categoryOptions) {
    if (parent.value === id) {
      return parent.label;
    }

    if (Array.isArray(parent.children)) {
      for (const child of parent.children) {
        if (child.value === id && length === 2) {
          return child.label;
        }

        if (length === 3 && Array.isArray(child.children)) {
          for (const subChild of child.children) {
            if (subChild.value === id) {
              return subChild.label;
            }
          }
        }
      }
    }
  }

  return null; // Not found
}

export function getCategoryIdPath(productCateOptions, parentId, innerMostId, categoryName) {
  for (const parent of productCateOptions) {
    if (parent.value !== parentId) continue;

    if (!Array.isArray(parent.children)) {
      return [parentId]; // No children at all
    }

    for (const child of parent.children) {
      if (child.value === innerMostId && child.label?.toLowerCase() == categoryName?.toLowerCase()) {
        // Direct child match: one-level
        return [parentId, innerMostId];
      }

      if (child.value === -1 && Array.isArray(child.children)) {
        for (const subChild of child.children) {
          if (subChild.value === innerMostId && subChild.label?.toLowerCase() == categoryName?.toLowerCase()) {
            // Found in sub-level under Unique
            return [parentId, -1, innerMostId];
          }
        }
      }
    }
  }

  return []; // Not found
}

// src/utils/attributeUtils.js

export async function getAttributeList(type, cid) {
  let param = { pageNum: 1, pageSize: 100, type: type };
  const response = await fetchProductAttrList(cid, param);
  let list = response.data.list;

  let selectedAttributes = [];
  let selectedParameters = [];

  if (type === 0) {
    for (let i = 0; i < list.length; i++) {
      selectedAttributes.push({
        id: list[i].id,
        name: list[i].name,
        value: null,
        inputType: list[i].inputType,
        inputList: list[i].inputList
      });
    }
    return { selectedAttributes };
  } else {
    for (let i = 0; i < list.length; i++) {
      selectedParameters.push({
        id: list[i].id,
        name: list[i].name,
        value: null,
        inputType: list[i].inputType,
        inputList: list[i].inputList
      });
    }
    return { selectedParameters };
  }
}

export function formatGold(wtUnit, rawWt) {
  
  let result = {
    wt : null,
    wtTotal : null
  };
  if (wtUnit == 3) {
    
    var yway = (parseFloat(this.rawWt.totalY) || 0) 
    var pal = (parseFloat(this.rawWt.totalP) || 0) 
    var kyat = (parseFloat(this.rawWt.totalK) || 0)

    if (yway < 0) {
      pal -= 1
      yway += 7.5
    } else if (yway >= 7.5) {
      var c = Math.trunc(yway / 7.5)
      pal += c
      yway -= c * 7.5
    }
    if (pal <
      0) {
      kyat -= 1
      pal += 16
    } else if (pal >= 16) {
      var c = Math.trunc(pal / 16)
      kyat += c
      pal -= c * 16
    }
   
    result.wt = kyat + (pal / 16) + (yway / (16 * 7.5))
    result.wtTotal = (rawWt.totalK || 0) + "-" + (rawWt.totalP || 0) + "-" + (rawWt.totalY || 0)
   
  } else {
    var temp = (parseFloat(this.rawWt.totalG) || 0) 
    rawWt.netG = temp

  result.wt = rawWt.netG
  result.wtTotal = rawWt.totalG + ""
  }

}

export function  generateKey() {
  // Generate a 16-byte random array
  const randomBytes = crypto.getRandomValues(new Uint8Array(16));
  
  // Convert it to a Base64 string
  return btoa(String.fromCharCode(...randomBytes));
} 

export function getInventoryType(selectedCategory, skuCode) {
  if (skuCode) {
    const shopDataStore = useShopDataStore();
    const sku = shopDataStore.defaultSkuList.find(s => s.code === skuCode);
    if (sku) return sku.inventoryType;
  }

  if (selectedCategory?.length === 3) return inventoryType.UniqueInventory.id;
  if (selectedCategory?.[0] === 75) return inventoryType.GoldInventory.id;
  return inventoryType.FixedInventory.id;
}